import { Box, Typography } from "@mui/material";

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export const RecordingIndicator = ({ recordingTime }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      py: 1,
      mb: 0.5,
    }}
  >
    <Box
      sx={{
        width: 12,
        height: 12,
        backgroundColor: "error.main",
        borderRadius: "50%",
        animation: "blink 1s infinite",
        "@keyframes blink": {
          "0%, 50%": { opacity: 1 },
          "51%, 100%": { opacity: 0.3 },
        },
        mr: 1,
      }}
    />
    <Typography variant="body2" color="error.main" fontWeight="bold">
      Recording... {formatTime(recordingTime)}
    </Typography>
  </Box>
);
